import withLazy from 'hoc/withLazy';

const Helper = () =>
    import(/* webpackChunkName: "components-Helper" */ './Helper');

export default withLazy(Helper);
